import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { CredibilitySection } from '../components/CredibilitySection';
import { AudienceSection } from '../components/AudienceSection';
import { TransformationSection } from '../components/TransformationSection';
import { FAQSection } from '../components/FAQSection';
import { ExpectationNoteSection } from '../components/ExpectationNoteSection';
import { PreCloseSection } from '../components/PreCloseSection';
import { WhatYouReceiveSection } from '../components/WhatYouReceiveSection';
import { OfferSection } from '../components/OfferSection';
import { LegalFooter } from '../components/LegalFooter';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
    __fbPixelReady: boolean;
  }
}
export function LandingPage() {
  return <main className="min-h-screen bg-white font-sans text-[#2D1F0E]" data-id="element-228">
      <HeroSection data-id="element-229" />
      <ProblemSection data-id="element-230" />
      <MechanismSection data-id="element-231" />
      <WhatYouGetSection data-id="element-232" />
      <CredibilitySection data-id="element-233" />
      <AudienceSection data-id="element-234" />
      <TransformationSection data-id="element-235" />
      <FAQSection data-id="element-236" />
      <ExpectationNoteSection data-id="element-237" />
      <PreCloseSection data-id="element-238" />
      <WhatYouReceiveSection data-id="element-239" />
      <OfferSection data-id="element-240" />
      <LegalFooter data-id="element-241" />
    </main>;
}